import React, {Fragment, useContext} from 'react';
import {Flex, UI, Text, TagsList, Popup, Gallery, Diary, Collaboration} from 'components';
import {moment, modal, useNamedSelector, over} from 'helpers';
import {store} from 'store';

export function Card({ id, context, inGroup, Status = Collaboration.CardStatus, ActionMenu = Popup.Menu.Handle, ...props }) {
  const openModal = useContext(Popup.Context)?.redirect ?? modal;
  const { Card, List } = UI;
  const { diary, editable, mood, disabled, images } = useNamedSelector('diary.details', { id, context: 'diary' });

  const attributes = {
    disabled,
    onClick: editable && context ? openModal(Diary.EditForm, ({id, context})) : undefined,
    navLink: editable && !context ? `/diary/${diary.date}/${diary.id}/` : undefined,
    ...props,
  }

  return (
    <Card {...attributes} id={id}>
      <Status selector="diary.details" id={id} />
      <ActionMenu Menu={Menu} diary={diary} id={id} attributes={attributes} editable={editable} disabled={disabled} />
      <Card.Body>
        { !context &&
          <Card.Text>{ diary.subject || 'Untitled' }</Card.Text>
        }
        { !diary.special && diary.text &&
          <div className="small-spacing">
            <Card.Note className="is-long-text">{ diary.text }</Card.Note>
          </div>
        }
        { diary && diary.questions &&
          <List>
            { diary.questions.map((question, index) =>
              <div key={question + index}>
                <b>{ question }</b>
                <Text className="tiny-spacing">{ diary[question] }</Text>
              </div>
            ) }
          </List>
        }
        { mood &&
          <Diary.MoodTable {...mood} />
        }
        <TagsList values={diary.tagIds} unclickable />
        <Gallery images={images} />
        { inGroup && props.className != 'has-right-menu' &&
          <p className="text-right secondary">
            <Card.Note>{ diary.time }</Card.Note>
          </p>
        }
      </Card.Body>

      <Card.Footer>
        <Flex className={['secondary', 'justified']}>
          <span>{ moment.unix(diary.date).calendar() }</span>
          { !inGroup &&
            <span>{ diary.time }</span>
          }
        </Flex>
      </Card.Footer>
    </Card>
  );
}

function Menu({diary, attributes, popup}) {
  return (
    <Fragment>
      <Popup.Menu.Item icon="pencil" to={attributes.navLink} onClick={over(attributes.onClick, popup.close)}>
        Edit
      </Popup.Menu.Item>
      <Collaboration.MenuItem id={diary.id} context="diary" />
      <Popup.Menu.DeleteItem onConfirm={() => store.dispatch({ type: 'DIARY_DELETE', id: diary.id })}>Delete</Popup.Menu.DeleteItem>
    </Fragment>
  );
}
